(function () {
  const root = document.querySelector('[data-diagnosis-app]');
  if (!root) return;

  const config = window.GOENCHA_DIAGNOSIS_CONFIG || {};
  const lpRoot = root.closest('[data-diagnosis-lp]');
  const supportSections = lpRoot ? lpRoot.querySelectorAll('[data-diagnosis-support]') : [];
  const TYPES = [
    ['INTJ', '静かな余白を育てる人', '静かな集中に寄り添うお茶時間'],
    ['INTP', 'ひらめきをほどく人', 'ひらめきを整える香ばしさ'],
    ['ENTJ', 'まっすぐ道をひらく人', '前へ進む人の和紅茶'],
    ['ENTP', 'ふふっと風を起こす人', '明るい予感を添える一杯'],
    ['INFJ', '気持ちをそっと汲む人', 'やさしく深いぬくもり'],
    ['INFP', 'やさしい物語を持つ人', '物語に花を添えるお茶'],
    ['ENFJ', 'ご縁をあたためる人', 'ご縁をやさしくあたためる'],
    ['ENFP', 'わくわくを分け合う人', 'わくわくを運ぶ彩り'],
    ['ISTJ', '日々をきちんと整える人', 'いつもの時間に安心感を'],
    ['ISFJ', 'そっと支える人', '静かなやさしさを重ねる'],
    ['ESTJ', '頼れる段取り上手な人', '切り替え上手の和紅茶'],
    ['ESFJ', '場をやさしく整える人', '場をほっと包むラテ'],
    ['ISTP', 'すっきり見極める人', 'すっきり香ばしく整える'],
    ['ISFP', '好きの手ざわりを知る人', '好きに寄り添うごほうび'],
    ['ESTP', '今を軽やかに楽しむ人', '今を明るく楽しむお茶'],
    ['ESFP', '気持ちをぱっと咲かせる人', '気持ちをぱっと咲かせる']
  ];

  const TYPE_TEASERS = {
    INTJ: '余白タイプ',
    INTP: 'ひらめきタイプ',
    ENTJ: '道ひらきタイプ',
    ENTP: '風おこしタイプ',
    INFJ: '気持ちタイプ',
    INFP: 'ものがたりタイプ',
    ENFJ: 'ご縁タイプ',
    ENFP: 'わくわくタイプ',
    ISTJ: 'きちんとタイプ',
    ISFJ: 'そっと支えるタイプ',
    ESTJ: '段取りタイプ',
    ESFJ: '場づくりタイプ',
    ISTP: '見極めタイプ',
    ISFP: '好きの手ざわりタイプ',
    ESTP: '今を楽しむタイプ',
    ESFP: 'ぱっと咲かせるタイプ'
  };

  const QUESTIONS = [
    {
      id: 'q1',
      title: '今の気分に近いものは？',
      options: [
        ['A', '今日は、ほっとひと息つきたい'],
        ['B', '少し気分を明るくしたい'],
        ['C', '頭と気持ちをすっきり整えたい'],
        ['D', '自分に小さなごほうびをあげたい']
      ]
    },
    {
      id: 'q2',
      title: 'どんなお茶時間にしたい？',
      options: [
        ['A', 'ひと息ついて、気軽にたのしみたい'],
        ['B', 'たっぷり飲んで、ゆっくり過ごしたい'],
        ['C', 'いろんな味や柄を、少しずつ試したい'],
        ['D', 'ふと誰かを思い出す時間にしたい']
      ]
    },
    {
      id: 'q3',
      title: '惹かれる雰囲気はどれですか？',
      options: [
        ['A', 'ふふっとかわいい'],
        ['B', 'すっと上品'],
        ['C', 'ほっとやさしい'],
        ['D', 'ぱっと華やぐ'],
        ['E', 'すっきり余白']
      ]
    }
  ];

  const state = {
    type: '',
    questionIndex: 0,
    answers: {},
    result: null
  };

  const screens = {
    type: root.querySelector('[data-app-screen="type"]'),
    questions: root.querySelector('[data-app-screen="questions"]'),
    loading: root.querySelector('[data-app-screen="loading"]'),
    result: root.querySelector('[data-app-screen="result"]'),
    error: root.querySelector('[data-app-screen="error"]')
  };

  const els = {
    appHeading: root.querySelector('[data-app-heading]'),
    appSubheading: root.querySelector('[data-app-subheading]'),
    typeGrid: root.querySelector('[data-type-grid]'),
    choiceGrid: root.querySelector('[data-choice-grid]'),
    questionCount: root.querySelector('[data-question-count]'),
    questionTitle: root.querySelector('[data-question-title]'),
    nextButton: root.querySelector('[data-next-question]'),
    nextLabel: root.querySelector('[data-next-label]'),
    prevButton: root.querySelector('[data-prev-question]'),
    selectedType: root.querySelector('[data-selected-type]'),
    message: root.querySelector('[data-app-message]'),
    resultImageWrap: root.querySelector('.diagnosis-app__result-image-wrap'),
    resultImage: root.querySelector('[data-result-image]'),
    resultPlaceholder: root.querySelector('[data-result-placeholder]'),
    resultName: root.querySelector('[data-result-name]'),
    teaType: root.querySelector('[data-tea-type]'),
    resultCopy: root.querySelector('[data-result-copy]'),
    teaNote: root.querySelector('[data-tea-note]'),
    teaReason: root.querySelector('[data-tea-reason]'),
    teaTime: root.querySelector('[data-tea-time]'),
    teaTimeText: root.querySelector('[data-tea-time-text]'),
    productsSection: root.querySelector('[data-products-section]'),
    products: root.querySelector('[data-products]'),
    shareSection: root.querySelector('[data-share-section]'),
    shareImage: root.querySelector('[data-share-image]'),
    shareX: root.querySelector('[data-share-x]'),
    shareLine: root.querySelector('[data-share-line]'),
    shareStatus: root.querySelector('[data-share-status]'),
    shareManual: root.querySelector('[data-share-manual]'),
    shareManualUrl: root.querySelector('[data-share-manual-url]'),
    copyUrl: root.querySelector('[data-copy-url]'),
    copyLabel: root.querySelector('[data-copy-label]'),
    errorTitle: root.querySelector('[data-error-title]'),
    errorText: root.querySelector('[data-error-text]'),
    fallbackLink: root.querySelector('[data-fallback-link]'),
    appStartLabel: root.querySelector('[data-app-start-label]')
  };

  const STEP_COPY = {
    type: {
      label: 'ここから診断スタート',
      heading: 'STEP 1　あなたに近い16タイプを選ぶ',
      subheading: 'まずは、お茶時間の入口になるタイプを選びましょう。直感で大丈夫です。'
    },
    questions: {
      label: '診断中',
      heading: 'STEP 2　3つの質問に答える',
      subheading: '今の気分や好きな雰囲気を教えてください。おすすめにそっと反映します。'
    },
    loading: {
      label: '診断中',
      heading: 'STEP 3　診断結果を準備中',
      subheading: 'あなたに合うごえん茶を探しています。茶葉をそっと選んでいます。'
    },
    result: {
      label: '診断結果',
      heading: 'STEP 3　診断結果',
      subheading: 'あなたのごえん茶タイプと、このお茶時間に合うごえん茶が見つかりました。'
    },
    error: {
      label: 'お知らせ',
      heading: '診断結果を表示できませんでした',
      subheading: '時間をおいてもう一度お試しください。'
    }
  };

  const QUESTION_MOTIFS = ['湯気', '手紙', '花'];
  const API_TIMEOUT_MS = 20000;
  let copyStatusTimer = 0;

  const dispatchEvent = (event, detail) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event }, detail || {}));
  };

  const clearChildren = (node) => {
    if (!node) return;
    while (node.firstChild) node.removeChild(node.firstChild);
  };

  const createNode = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const isSafeUrl = (value, allowed) => {
    if (!value || typeof value !== 'string') return false;
    try {
      const url = new URL(value, window.location.origin);
      return allowed.some((rule) => {
        if (rule instanceof RegExp) return rule.test(url.toString());
        return url.origin === rule;
      });
    } catch (error) {
      return false;
    }
  };

  const safeProductUrl = (value) => {
    if (!isSafeUrl(value, ['https://shop.goencha.com', window.location.origin])) return '';
    const url = new URL(value, window.location.origin);
    return url.pathname.startsWith('/products/') ? url.toString() : '';
  };

  const safeImageUrl = (value) => {
    if (!value || typeof value !== 'string') return '';
    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'https:' ? url.toString() : '';
    } catch (error) {
      return '';
    }
  };

  const getTypeInfo = (code) => {
    const normalized = String(code || '').toUpperCase();
    const row = TYPES.find((type) => type[0] === normalized);
    return row ? { code: row[0], name: row[1], copy: row[2] } : null;
  };

  const getTypeTeaser = (code) => TYPE_TEASERS[String(code || '').toUpperCase()] || '';

  const getTypeCharacter = (code) => {
    const normalized = String(code || '').toUpperCase();
    const raw = config.typeCharacters && config.typeCharacters[normalized];
    if (!raw) return null;

    const thumbnail = safeImageUrl(raw.thumbnail);
    const image = safeImageUrl(raw.image);
    if (!thumbnail && !image) return null;

    return {
      thumbnail,
      image,
      alt: String(raw.alt || '')
    };
  };

  const createCharacterImage = (url, alt, className) => {
    const image = document.createElement('img');
    image.className = className;
    image.src = url;
    image.alt = alt || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 320;
    image.height = 540;
    return image;
  };

  const getConfiguredPublicUrl = () => {
    try {
      return new URL(config.publicBaseUrl || '/pages/goencha-diagnosis', window.location.origin);
    } catch (error) {
      return new URL('/pages/goencha-diagnosis', window.location.origin);
    }
  };

  const safeShareUrl = (value) => {
    const publicUrl = getConfiguredPublicUrl();
    const allowedOrigins = Array.from(new Set(['https://shop.goencha.com', window.location.origin, publicUrl.origin]));
    if (!isSafeUrl(value, allowedOrigins)) return '';
    const url = new URL(value, window.location.origin);
    return url.pathname === publicUrl.pathname ? url.toString() : '';
  };

  const buildSocialShareUrl = (resultId) => {
    const rawBaseUrl = String(config.shareBaseUrl || config.apiBaseUrl || '').trim();
    if (!resultId || !isSafeUrl(rawBaseUrl, ['https://goencha.com'])) return '';
    try {
      const url = new URL(rawBaseUrl);
      if (url.origin !== 'https://goencha.com') return '';
      url.searchParams.set('result_id', resultId);
      return url.toString();
    } catch (error) {
      return '';
    }
  };

  const getShareImageUrl = (data) => {
    const image = data && data.image ? data.image : {};
    return safeImageUrl(image.story_url)
      || safeImageUrl(image.square_url)
      || safeImageUrl(image.ogp_url);
  };

  const formatTeaTypeLabel = (value) => {
    const text = String(value || '').trim();
    return text.replace(/^はなぎょくろ\s+(あか|あお|きみどり|だいだい)$/, 'はなぎょくろ $1色');
  };

  const normalizeTeaTypeInText = (text, teaType) => {
    const source = String(text || '');
    const rawTeaType = String(teaType || '').trim();
    const displayTeaType = formatTeaTypeLabel(rawTeaType);
    if (!source || !rawTeaType || rawTeaType === displayTeaType) return source;
    return source.split(rawTeaType).join(displayTeaType);
  };

  const removeUrlsFromShareText = (text) => String(text || '')
    .replace(/https?:\/\/\S+/g, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  const buildShareText = (data) => {
    const apiText = String((data.share && data.share.text) || '').trim();
    if (apiText) return removeUrlsFromShareText(normalizeTeaTypeInText(apiText, data.tea_type));

    const resultName = String(data.result_name || '').trim();
    const teaType = formatTeaTypeLabel(data.tea_type);
    const lines = ['わたしのごえん茶診断は'];
    if (resultName) lines.push(`「${resultName}」タイプでした。`);
    if (teaType) lines.push('', `おすすめのお茶は、${teaType}。`);
    lines.push('', '今日のあなたに合うお茶時間も見つけてみてください。', '#ごえん茶診断');
    return lines.join('\n');
  };

  const formatPrice = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return '';
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      maximumFractionDigits: 0
    }).format(numeric);
  };

  const truncateText = (value, length) => {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (text.length <= length) return text;
    return `${text.slice(0, length - 1)}…`;
  };

  const showMessage = (text) => {
    if (!els.message) return;
    if (!text) {
      els.message.hidden = true;
      els.message.textContent = '';
      return;
    }
    els.message.textContent = text;
    els.message.hidden = false;
  };

  const setLpMode = (mode) => {
    if (!lpRoot) return;
    const isAppActive = mode === 'app';
    const isResultActive = mode === 'result';

    lpRoot.classList.toggle('diagnosis-lp--app-active', isAppActive);
    lpRoot.classList.toggle('diagnosis-lp--result-active', isResultActive);

    supportSections.forEach((section) => {
      const shouldHide = isAppActive || isResultActive;
      section.hidden = shouldHide;
      section.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
    });
  };

  const showScreen = (name) => {
    root.dataset.currentScreen = name;

    Object.keys(screens).forEach((key) => {
      if (screens[key]) screens[key].hidden = key !== name;
    });

    root.querySelectorAll('[data-progress-step]').forEach((item) => {
      item.classList.remove('is-active', 'is-complete');
    });

    const typeStep = root.querySelector('[data-progress-step="type"]');
    const questionStep = root.querySelector('[data-progress-step="questions"]');
    const resultStep = root.querySelector('[data-progress-step="result"]');

    const copyKey = name === 'loading' ? 'loading' : name === 'error' ? 'error' : name === 'result' ? 'result' : name === 'questions' ? 'questions' : 'type';
    const copy = STEP_COPY[copyKey];
    if (copy) {
      if (els.appStartLabel) els.appStartLabel.textContent = copy.label || '';
      if (els.appHeading) els.appHeading.textContent = copy.heading;
      if (els.appSubheading) els.appSubheading.textContent = copy.subheading;
    }

    if (name === 'type') {
      typeStep && typeStep.classList.add('is-active');
    } else if (name === 'questions') {
      typeStep && typeStep.classList.add('is-complete');
      questionStep && questionStep.classList.add('is-active');
    } else if (name === 'loading') {
      typeStep && typeStep.classList.add('is-complete');
      questionStep && questionStep.classList.add('is-complete');
      resultStep && resultStep.classList.add('is-active');
    } else {
      typeStep && typeStep.classList.add('is-complete');
      questionStep && questionStep.classList.add('is-complete');
      resultStep && resultStep.classList.add('is-active');
    }
  };

  const scrollToApp = () => {
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  };

  const scrollToScreen = (name) => {
    const target = name === 'questions' || name === 'loading' || name === 'result' || name === 'error'
      ? root
      : screens[name] || root;
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  };

  const scrollToElement = (element) => {
    if (!element) return;
    element.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  };

  const scrollQuestionActionIntoView = () => {
    const target = els.nextButton && els.nextButton.closest('.diagnosis-app__actions');
    if (!target) return;
    window.setTimeout(() => {
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }, 40);
  };

  const postApi = async (payload) => {
    const apiBaseUrl = String(config.apiBaseUrl || '');
    if (!isSafeUrl(apiBaseUrl, ['https://goencha.com'])) {
      throw new Error('api_not_configured');
    }

    const requestOptions = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    };
    let response;
    if (typeof AbortController === 'function') {
      const controller = new AbortController();
      const abortId = window.setTimeout(() => controller.abort(), API_TIMEOUT_MS);
      try {
        response = await fetch(apiBaseUrl, Object.assign({}, requestOptions, { signal: controller.signal }));
      } catch (error) {
        if (error && error.name === 'AbortError') throw new Error('api_timeout');
        throw error;
      } finally {
        window.clearTimeout(abortId);
      }
    } else {
      let timeoutId;
      const timeoutPromise = new Promise((_, reject) => {
        timeoutId = window.setTimeout(() => reject(new Error('api_timeout')), API_TIMEOUT_MS);
      });
      try {
        response = await Promise.race([fetch(apiBaseUrl, requestOptions), timeoutPromise]);
      } finally {
        window.clearTimeout(timeoutId);
      }
    }

    let data;
    try {
      data = await response.json();
    } catch (error) {
      throw new Error('invalid_api_response');
    }

    if (!response.ok || !data || data.ok !== true) {
      const apiError = new Error(data && data.error ? data.error : 'api_error');
      apiError.apiResponse = data;
      throw apiError;
    }

    return data;
  };

  const renderTypes = () => {
    if (!els.typeGrid) return;
    clearChildren(els.typeGrid);
    TYPES.forEach(([code]) => {
      const character = getTypeCharacter(code);
      const teaserName = getTypeTeaser(code) || code;
      const button = createNode('button', 'diagnosis-app__type-card');
      button.type = 'button';
      button.dataset.type = code;
      button.setAttribute('aria-label', `${code} ${teaserName}`);
      button.setAttribute('aria-pressed', state.type === code ? 'true' : 'false');
      if (state.type === code) button.classList.add('is-selected');

      if (character && character.thumbnail) {
        const thumbnail = createNode('span', 'diagnosis-app__type-thumb');
        const image = createCharacterImage(character.thumbnail, '', 'diagnosis-app__type-thumb-image');
        image.setAttribute('aria-hidden', 'true');
        thumbnail.appendChild(image);
        button.appendChild(thumbnail);
      }

      const body = createNode('span', 'diagnosis-app__type-body');
      body.appendChild(createNode('span', 'diagnosis-app__type-code', code));
      body.appendChild(createNode('span', 'diagnosis-app__type-name', teaserName));
      button.appendChild(body);
      button.addEventListener('click', () => selectType(code));
      els.typeGrid.appendChild(button);
    });
  };

  const renderSelectedType = () => {
    if (!els.selectedType) return;
    clearChildren(els.selectedType);

    const type = getTypeInfo(state.type);
    if (!type) {
      els.selectedType.hidden = true;
      return;
    }

    const character = getTypeCharacter(type.code);
    if (character && character.image) {
      const visual = createNode('span', 'diagnosis-app__selected-type-visual');
      visual.appendChild(createCharacterImage(character.image, character.alt, 'diagnosis-app__selected-type-image'));
      els.selectedType.appendChild(visual);
    }

    const text = createNode('span', 'diagnosis-app__selected-type-text');
    const teaserName = getTypeTeaser(type.code) || type.name;
    text.appendChild(createNode('span', 'diagnosis-app__selected-type-label', '選んだタイプ'));
    text.appendChild(createNode('span', 'diagnosis-app__selected-type-name', `${type.code}　${teaserName}`));
    els.selectedType.appendChild(text);
    els.selectedType.hidden = false;
  };

  const selectType = (code) => {
    state.type = code;
    setLpMode('app');
    dispatchEvent('diagnosis_type_selected', { mbti_type: code });
    renderTypes();
    state.questionIndex = 0;
    state.answers = {};
    renderQuestion();
    showScreen('questions');
    showMessage('');
    scrollToScreen('questions');
  };

  const renderQuestion = () => {
    const question = QUESTIONS[state.questionIndex];
    if (!question) return;
    if (!els.questionCount || !els.questionTitle || !els.choiceGrid) return;

    els.questionCount.textContent = `Q${state.questionIndex + 1} / ${QUESTIONS.length}`;
    els.questionTitle.textContent = question.title;
    els.choiceGrid.dataset.optionCount = String(question.options.length);
    if (screens.questions) screens.questions.dataset.questionStep = String(state.questionIndex + 1);
    const motif = root.querySelector('[data-question-motif]');
    if (motif) motif.textContent = QUESTION_MOTIFS[state.questionIndex] || '';
    renderSelectedType();
    clearChildren(els.choiceGrid);

    question.options.forEach(([id, text]) => {
      const button = createNode('button', 'diagnosis-app__choice');
      button.type = 'button';
      button.dataset.optionId = id;
      button.setAttribute('aria-pressed', state.answers[question.id] === id ? 'true' : 'false');
      if (state.answers[question.id] === id) button.classList.add('is-selected');
      button.appendChild(createNode('span', 'diagnosis-app__choice-id', id));
      button.appendChild(createNode('span', 'diagnosis-app__choice-text', text));
      button.addEventListener('click', () => selectAnswer(question.id, id));
      els.choiceGrid.appendChild(button);
    });

    els.prevButton.hidden = state.questionIndex === 0;
    els.nextButton.disabled = !state.answers[question.id];
    els.nextLabel.textContent = state.questionIndex === QUESTIONS.length - 1 ? '診断結果を見る' : '次の質問へ';
  };

  const selectAnswer = (questionId, optionId) => {
    state.answers[questionId] = optionId;
    dispatchEvent('diagnosis_question_answered', {
      question_id: questionId,
      option_id: optionId
    });
    renderQuestion();
    scrollQuestionActionIntoView();
  };

  const goNext = () => {
    const question = QUESTIONS[state.questionIndex];
    if (!question || !state.answers[question.id]) return;

    if (state.questionIndex < QUESTIONS.length - 1) {
      state.questionIndex += 1;
      renderQuestion();
      scrollToScreen('questions');
      return;
    }

    createResult();
  };

  const goPrev = () => {
    if (state.questionIndex === 0) return;
    state.questionIndex -= 1;
    renderQuestion();
    scrollToScreen('questions');
  };

  const createResult = async () => {
    if (!state.type || !state.answers.q1 || !state.answers.q2 || !state.answers.q3) return;
    setLpMode('app');
    showScreen('loading');
    showMessage('');
    scrollToScreen('loading');

    try {
      const data = await postApi({
        mode: 'create',
        mbti_type: state.type,
        q1: state.answers.q1,
        q2: state.answers.q2,
        q3: state.answers.q3,
        source: config.source || 'shopify_diagnosis'
      });
      renderResult(data);
      setLpMode('result');
      dispatchEvent('diagnosis_complete', {
        result_id: data.result_id,
        mbti_type: data.mbti_type
      });
      showScreen('result');
      updateUrl(data.result_id);
      scrollToScreen('result');
    } catch (error) {
      showError('診断結果を作成できませんでした', '時間をおいてもう一度お試しください。別ページの診断もご利用いただけます。', error.message);
    }
  };

  const getResult = async (resultId) => {
    setLpMode('app');
    showScreen('loading');
    showMessage('');
    scrollToScreen('loading');

    try {
      const data = await postApi({
        mode: 'get',
        result_id: resultId
      });
      renderResult(data);
      setLpMode('result');
      showScreen('result');
      scrollToScreen('result');
    } catch (error) {
      showError('診断結果が見つかりませんでした', 'もう一度診断すると、新しい結果を作成できます。', error.message);
    }
  };

  const updateUrl = (resultId) => {
    if (!resultId || !config.publicBaseUrl) return;
    try {
      const url = new URL(config.publicBaseUrl);
      url.searchParams.set('result_id', resultId);
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      return;
    }
  };

  const renderResult = (data) => {
    state.result = data;
    els.resultName.textContent = data.result_name || '';
    const teaTypeLabel = formatTeaTypeLabel(data.tea_type);
    els.teaType.textContent = teaTypeLabel ? `おすすめのお茶：${teaTypeLabel}` : '';
    els.resultCopy.textContent = data.result_copy || '';
    const teaReasonText = String(data.tea_reason_text || '').trim();
    if (els.teaNote && els.teaReason) {
      if (teaReasonText) {
        els.teaReason.textContent = teaReasonText;
        els.teaNote.hidden = false;
      } else {
        els.teaReason.textContent = '';
        els.teaNote.hidden = true;
      }
    }
    const teaTimeText = String(data.tea_time_text || '').trim();
    if (els.teaTime && els.teaTimeText) {
      if (teaTimeText) {
        els.teaTimeText.textContent = teaTimeText;
        els.teaTime.hidden = false;
      } else {
        els.teaTimeText.textContent = '';
        els.teaTime.hidden = true;
      }
    }

    const character = getTypeCharacter(data.mbti_type || state.type);
    const characterImageUrl = character && character.image ? character.image : '';
    const squareImageUrl = safeImageUrl(data.image && data.image.square_url);
    const imageUrl = squareImageUrl || characterImageUrl;
    const isCharacterImage = Boolean(!squareImageUrl && characterImageUrl);
    if (imageUrl) {
      els.resultImage.src = imageUrl;
      els.resultImage.alt = isCharacterImage && character ? character.alt : `${data.result_name || '診断結果'} 画像`;
      els.resultImage.hidden = false;
      els.resultPlaceholder.hidden = true;
    } else {
      els.resultImage.removeAttribute('src');
      els.resultImage.hidden = true;
      els.resultPlaceholder.hidden = false;
    }
    if (els.resultImageWrap) {
      els.resultImageWrap.classList.toggle('is-character', isCharacterImage);
    }

    renderProducts(Array.isArray(data.products) ? data.products : []);
    renderShare(data);
  };

  const renderProducts = (products) => {
    if (!els.products) return;
    clearChildren(els.products);

    const visibleProducts = products.slice(0, 3);
    if (!visibleProducts.length) {
      const empty = createNode(
        'p',
        'diagnosis-app__products-empty',
        'このお茶時間に合うごえん茶を準備できませんでした。時間をおいて、もう一度お試しください。'
      );
      els.products.appendChild(empty);
      return;
    }

    visibleProducts.forEach((product) => {
      const url = safeProductUrl(product.url);
      const imageUrl = safeImageUrl(product.image_url);
      const card = document.createElement(url ? 'a' : 'div');
      card.className = 'diagnosis-app__product-card';
      if (url) {
        card.href = url;
        card.target = '_blank';
        card.rel = 'noopener';
        card.dataset.eventName = 'diagnosis_product_click';
        card.addEventListener('click', () => {
          dispatchEvent('diagnosis_product_click', {
            handle: String(product.handle || ''),
            url
          });
        });
      }

      const imageWrap = createNode('div', 'diagnosis-app__product-image-wrap');
      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'diagnosis-app__product-image';
        image.src = imageUrl;
        image.alt = product.title ? `${product.title}の画像` : 'おすすめのごえん茶の画像';
        image.loading = 'lazy';
        image.decoding = 'async';
        imageWrap.appendChild(image);
      }
      card.appendChild(imageWrap);

      const body = createNode('div', 'diagnosis-app__product-body');
      if (product.role_label) {
        body.appendChild(createNode('div', 'diagnosis-app__product-role', product.role_label));
      }
      body.appendChild(createNode('div', 'diagnosis-app__product-title', product.title || 'おすすめのごえん茶'));
      body.appendChild(createNode('div', 'diagnosis-app__product-comment', truncateText(product.comment || '', 72)));

      const foot = createNode('div', 'diagnosis-app__product-foot');
      foot.appendChild(createNode('span', 'diagnosis-app__price', formatPrice(product.price)));
      foot.appendChild(createNode('span', 'diagnosis-app__product-cta', '詳しく見る →'));
      body.appendChild(foot);
      card.appendChild(body);
      els.products.appendChild(card);
    });
  };

  const renderShare = (data) => {
    window.clearTimeout(copyStatusTimer);
    const resultPageUrl = safeShareUrl(data.share && data.share.url) || buildShareUrl(data.result_id);
    const socialShareUrl = buildSocialShareUrl(data.result_id) || resultPageUrl;
    const shareImageUrl = getShareImageUrl(data);
    const shareText = buildShareText(data);
    const encodedUrl = encodeURIComponent(socialShareUrl);
    const encodedText = encodeURIComponent(shareText);

    if (els.shareImage) {
      if (shareImageUrl) {
        els.shareImage.href = shareImageUrl;
        els.shareImage.hidden = false;
      } else {
        els.shareImage.removeAttribute('href');
        els.shareImage.hidden = true;
      }
    }
    if (els.shareSection) {
      els.shareSection.classList.toggle('has-image', Boolean(shareImageUrl));
    }
    if (els.shareX) {
      els.shareX.href = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
    }
    if (els.shareLine) {
      els.shareLine.href = `https://social-plugins.line.me/lineit/share?url=${encodedUrl}`;
    }
    if (els.copyUrl) {
      els.copyUrl.dataset.copyValue = resultPageUrl;
      if (els.copyLabel) els.copyLabel.textContent = 'URLをコピー';
    }
    if (els.shareStatus) {
      els.shareStatus.textContent = '';
      els.shareStatus.hidden = true;
    }
    if (els.shareManual) {
      els.shareManual.hidden = true;
    }
    if (els.shareManualUrl) {
      els.shareManualUrl.value = resultPageUrl;
    }
  };

  const buildShareUrl = (resultId) => {
    try {
      const url = new URL(config.publicBaseUrl || window.location.href);
      if (resultId) url.searchParams.set('result_id', resultId);
      return url.toString();
    } catch (error) {
      return window.location.href;
    }
  };

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }

    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      return document.execCommand('copy');
    } finally {
      textarea.remove();
    }
  };

  const showManualShareUrl = (value) => {
    if (!els.shareManual || !els.shareManualUrl) return;
    els.shareManualUrl.value = value;
    els.shareManual.hidden = false;
    els.shareManualUrl.focus();
    els.shareManualUrl.select();
  };

  const showError = (title, text, code) => {
    setLpMode('app');
    if (els.errorTitle) els.errorTitle.textContent = title;
    if (els.errorText) els.errorText.textContent = text;
    if (els.fallbackLink && config.fallbackGasUrl && isSafeUrl(config.fallbackGasUrl, ['https://script.google.com'])) {
      els.fallbackLink.href = config.fallbackGasUrl;
      els.fallbackLink.hidden = false;
    } else if (els.fallbackLink) {
      els.fallbackLink.hidden = true;
    }
    dispatchEvent('diagnosis_error', { error_code: code || 'unknown' });
    showScreen('error');
    scrollToScreen('error');
  };

  const restart = () => {
    setLpMode('app');
    state.type = '';
    state.questionIndex = 0;
    state.answers = {};
    state.result = null;
    renderTypes();
    renderSelectedType();
    showMessage('');
    showScreen('type');
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('result_id');
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      // Preview URLs can reject history updates; the UI reset should still continue.
    }
    scrollToApp();
  };

  root.querySelectorAll('[data-restart-diagnosis]').forEach((button) => {
    button.addEventListener('click', restart);
  });

  root.querySelectorAll('[data-event-name="diagnosis_share_click"]').forEach((target) => {
    target.addEventListener('click', () => {
      dispatchEvent('diagnosis_share_click', {
        channel: target.dataset.shareChannel || ''
      });
    });
  });

  if (els.copyUrl) {
    els.copyUrl.addEventListener('click', async () => {
      const value = els.copyUrl.dataset.copyValue || buildShareUrl(state.result && state.result.result_id);
      try {
        const copied = await copyText(value);
        if (!copied) throw new Error('copy_failed');
        if (els.copyLabel) els.copyLabel.textContent = 'コピーしました';
        copyStatusTimer = window.setTimeout(() => {
          if (els.copyLabel) els.copyLabel.textContent = 'URLをコピー';
        }, 3600);
        if (els.shareManual) els.shareManual.hidden = true;
        if (els.shareStatus) {
          els.shareStatus.textContent = '結果URLをコピーしました。大切な人にも、ふふっと見せられます。';
          els.shareStatus.hidden = false;
        } else {
          showMessage('URLをコピーしました。');
        }
      } catch (error) {
        showManualShareUrl(value);
        if (els.shareStatus) {
          els.shareStatus.textContent = '自動コピーができませんでした。表示されたURLを長押ししてコピーしてください。';
          els.shareStatus.hidden = false;
        } else {
          showMessage('URLをコピーできませんでした。表示されたURLを長押ししてコピーしてください。');
        }
      }
    });
  }

  els.nextButton && els.nextButton.addEventListener('click', goNext);
  els.prevButton && els.prevButton.addEventListener('click', goPrev);

  document.querySelectorAll('.js-diagnosis-app-scroll').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      setLpMode('app');
      dispatchEvent('diagnosis_start', {
        cta: link.dataset.cta || 'diagnosis_lp'
      });
      scrollToApp();
    });
  });

  renderTypes();

  const params = new URLSearchParams(window.location.search);
  const resultId = params.get('result_id');
  if (/^gr_[A-Za-z0-9_-]{8,80}$/.test(resultId || '')) {
    getResult(resultId);
  } else {
    showScreen('type');
  }
})();
